import { Component, computed, input } from '@angular/core';
import { InfoMessageComponent } from '../info-message/info-message.component';
import { CalculationStatusDto } from '../../../core/mceapi.client.generated';

@Component({
  selector: 'app-calculation-box',
  imports: [InfoMessageComponent],
  templateUrl: './calculation-box.component.html',
  styles: ``,
})
export class CalculationBoxComponent {

  readonly status = input.required<CalculationStatusDto>();
  readonly loading = input<boolean>(false);

  viewState = computed(() => {
    const boxType: 'success' | 'warning' | 'error' | 'information' =
      this.status().case === "Success" ? 'success' :
        this.status().case === "Warning" ? 'warning' :
          this.status().case === "Error" ? 'error' : 'information';

    return {
      boxType,

      isSuccess: this.status().case === "Success",
      isWarning: this.status().case === "Warning",
      isError: this.status().case === "Error",
      isInfo: this.status().case === "Info",

      message: this.status().message,

      loading: this.loading()

    };
  });

}
